import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { ISibasiHTTPResponse } from '../../../../models/sibasiHTTPResponse.model';
import { UserRoles } from '../../../../models/user.model';
import { INav } from '../../../../_nav';

@Injectable({
  providedIn: 'root'
})
export class NavService {

  constructor(
    private httpClient: HttpClient
  ) { }

  getAllNavItems(): Observable<ISibasiHTTPResponse<INav[]>> {
    return this.httpClient.get<ISibasiHTTPResponse<INav[]>>(`${environment.api_url}/menu`);
  }

  createNavItems(navItems: INav[]): Observable<ISibasiHTTPResponse<INav>> {
    return this.httpClient.post<ISibasiHTTPResponse<INav>>(`${environment.api_url}/menu/admin/createMany`, navItems);
  }
  ////login in as system admin
  recreateMenuDefault(): Observable<ISibasiHTTPResponse<INav[]>> {
    return this.httpClient.post<ISibasiHTTPResponse<INav[]>>(`${environment.api_url}/menu/admin/recreateMenuDefault`, {});
  }
  // updateNavItem(navItem: INav, navId: string): Observable<ISibasiHTTPResponse<INav>> {
  //   return this.httpClient.post<ISibasiHTTPResponse<INav>>(`${environment.api_url}/user/admin/${navId}/updateUser`, navItem);
  // }

  deleteNavItem(navId: string): Observable<ISibasiHTTPResponse<INav>> {
    return this.httpClient.delete<ISibasiHTTPResponse<INav>>(`${environment.api_url}/menu/admin/delete/${navId}`);
  }

  deleteAllNavItems(): Observable<ISibasiHTTPResponse<INav>> {
    return this.httpClient.delete<ISibasiHTTPResponse<INav>>(`${environment.api_url}/menu/admin/delete/all`);
  }

  assignUserRole(role: {role: UserRoles}, navId: string): Observable<ISibasiHTTPResponse<INav>> {
    return this.httpClient.post<ISibasiHTTPResponse<INav>>(`${environment.api_url}/menu/admin/${navId}/assignRole`, role);
  }

  unAssignUserRole(role: {role: UserRoles}, navId: string): Observable<ISibasiHTTPResponse<INav>> {
    return this.httpClient.post<ISibasiHTTPResponse<INav>>(`${environment.api_url}/menu/admin/${navId}/removeRole`, role);
  }
}
